import { createFileRoute } from '@tanstack/react-router'
import DistributionLogs from 'Edition/components/sections/General/DistributionLogs'

export const Route = createFileRoute('/work/$workId_/edition/$editionId/distribution-logs')({
    component: DistributionLogs,
})
